import { render, staticRenderFns } from "./EditContactInformationOnk.vue?vue&type=template&id=04287295&"
import script from "./EditContactInformationOnk.vue?vue&type=script&lang=js&"
export * from "./EditContactInformationOnk.vue?vue&type=script&lang=js&"
import style0 from "./EditContactInformationOnk.vue?vue&type=style&index=0&id=04287295&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports